<template>
  <div :class="classes">
    <pt-page-title :title="(isEdit?'预约信息修改':'预约信息')"></pt-page-title>
    <pt-sub-title title="预约信息"></pt-sub-title>
    <template v-if="!isEdit">
      <div :class="$style['pt-work-order-detail']">
        <table>
          <tr>
            <td>用户：</td>
            <td>{{formValue.createName}}</td>
          </tr>
          <tr>
            <td>姓名：</td>
            <td>{{formValue.customerName}}</td>
          </tr>
          <tr>
            <td>产品：</td>
            <td >
              <span></span>
              <p v-for="(item,index) in formValue.subscribeValue" :key="index" :class="$style.proName">{{item}}</p>
            </td>
          </tr>
          <tr>
            <td>手机：</td>
            <td>{{formValue.customerPhone}}</td>
          </tr>
          <tr>
            <td>希望联系时间：</td>
            <td>{{formValue.subscribeDate}}</td>
          </tr>
          <tr>
            <td>预约提交时间：</td>
            <td>{{formValue.createdDate_change}}</td>
          </tr>
        </table>
      </div>
      <el-button type="primary" @click.native="toEdit">信息修改</el-button>
    </template>
    <template v-if="isEdit">
      <table :class="$style['publish-news-table']">
        <pt-form-list-item label="用户：" required>
          <wt-input v-model="formValue.createName" :class="$style['title']" data-vv-as="用户" name="title"
            v-validate="'required'" :disabled="true"></wt-input>
        </pt-form-list-item>
        <pt-form-list-item label="姓名：">
          <wt-input v-model="formValue.customerName" :class="$style['title']" data-vv-as="姓名"></wt-input>
        </pt-form-list-item>
        <pt-form-list-item label="产品：" required>
          <div :class="$style.checkbox">
            <wt-checkbox :checkList="proList" v-model="formValue.subscribeValue" style="line-height:40px"></wt-checkbox>
          </div>
        </pt-form-list-item>
        <pt-form-list-item label="手机：" required>
          <wt-input v-model="formValue.customerPhone" :class="$style['title']" data-vv-as="手机" name="title"
            v-validate="'required'"></wt-input>
        </pt-form-list-item>
        <pt-form-list-item label="希望联系时间：" required>
          <wt-selector :options="subscribeDate" v-model="formValue.subscribeDate" data-vv-as="希望联系时间：" name="title"
            v-validate="'required'"></wt-selector>
        </pt-form-list-item>
        <pt-form-list-item label="预约提交时间：" required>
          <wt-input v-model="formValue.createdDate_change" :class="$style['title']" data-vv-as="预约提交时间" name="title"
            v-validate="'required'" :disabled="true"></wt-input>
        </pt-form-list-item>
      </table>
      <el-button type="primary" @click.native="toSubmit">保存</el-button>
    </template>
  </div>
</template>

<script>
// 组件class前缀
import {
  subscribeDate
} from '../../work-order'
const prefixCls = 'pt-work-order-detail'

export default {
  name: 'pt-work-order-detail',
  computed: {
    classes () {
      return `${prefixCls}`
    }
  },
  data () {
    return {
      formValue: {},
      isEdit: false,
      subscribeDate: subscribeDate,
      proList: []
    }
  },
  methods: {
    getOrderWorkDetail () {
      this.$store.dispatch('getOrderWorkDetail', this.$route.params.id).then(res => {
        this.formValue = res
        this.$store.dispatch('getCommodityDetail', res.goodsId).then(ret => {
          let data = ret[0].items
          for (var i = 0; i < data.length; i++) {
            data[i].label = data[i].name
            data[i].value = data[i].name
          }
          this.proList = data
        }).catch(err => {
          this.$message.error(err || '获取预约类咨询工单详情失败')
        })
      }).catch(err => {
        this.$message.error(err || '获取预约类咨询工单详情失败')
      })
    },
    toEdit () {
      this.isEdit = true
    },
    toSubmit () {
      this.$store.dispatch('OrderWorkUpdate', this.formValue).then(res => {
        this.isEdit = false
      }).catch(err => {
        this.$message.error(err || '预约类咨询工单修改失败')
      })
    }
  },
  created () {
    this.getOrderWorkDetail()
  }
}

</script>

<style module lang="less">
  /* 已启用css module， template中请使用$style.className添加class */
  /* 务必遵循css BEM原则 */
  @import "~less/var.less";

  :global {
    .pt-work-order-detail {
      .el-checkbox+.el-checkbox {
        margin-left: 0
      }
    }

  }

  .pt-work-order-detail {

    padding: 50px 20px;
    display: flex;
    flex-direction: row;

    :global table {
      tr {
        td {
          line-height: 40px;
          font-size: 16px;

          img {
            max-width: 60px;
            height: auto
          }
        }

        :first-child {
          display: flex;
          color: @mainColor;
          justify-content: flex-end;
        }
      }
    }

    .el-checkbox+.el-checkbox {
      margin: 0
    }
  }

  .title {
    max-width: 300PX;
  }

  .checkbox {
    display: table-caption;
  }
  .proName{
    margin: 0
  }
</style>
